export const commandsSubMenu = {
  backgroundColor: 'var(--primary-color)',
} as React.CSSProperties;

export const sidebarOpenButton = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 16,
  width: 30,
  height: 30,
  borderRadius: 15,
  position: 'absolute',
  top: 200,
  zIndex: 5,
} as React.CSSProperties;

export const submenu = {
  backgroundColor: 'var(--primary-color)',
} as React.CSSProperties;
